import { render } from "./ModalAcceptDocs.vue?vue&type=template&id=22909675&scoped=true&ts=true"
import script from "./ModalAcceptDocs.vue?vue&type=script&lang=ts"
export * from "./ModalAcceptDocs.vue?vue&type=script&lang=ts"

import "./ModalAcceptDocs.vue?vue&type=style&index=0&id=22909675&lang=stylus&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22909675"]])

export default __exports__